export const POSITIONS = ["Portero", "Defensa", "Medio", "Delantero"];

// Mapa de valor interno → etiqueta visible en español
export const POSITION_LABELS = {
  Portero:   "Portero",
  Defensa:   "Defensa",
  Medio:     "Medio",
  Delantero: "Delantero",
};

export const FILTER_OPTIONS = [
  { value: "all",        label: "Todos" },
  { value: "Portero",    label: "Porteros" },
  { value: "Defensa",    label: "Defensas" },
  { value: "Medio",      label: "Medios" },
  { value: "Delantero",  label: "Delanteros" },
];

/**
 * Carga dinámicamente la imagen del jugador según la selección
 * @param {string} photoName - Nombre del archivo de la foto (ej: "/Alvaro-Fidalgo.png")
 * @param {string} selectionPath - Ruta de la selección (ej: "selection-mx", "selection-col")
 * @returns {string|null} - URL de la imagen o null si no existe
 */
export function getPlayerPhoto(photoName, selectionPath = "selection-mx") {
  if (!photoName) return null;
  try {
    const photoWithExtension = photoName.includes('.') ? photoName : `${photoName}.png`;
    return require(`../../assets/${selectionPath}/players${photoWithExtension}`);
  } catch (e) {
    console.warn(`Image not found: ${selectionPath}/players${photoName}`);
    return null;
  }
}

/**
 * En mobile la cancha es vertical (aspect-ratio 10/16).
 * En desktop la cancha es horizontal (aspect-ratio 16/10).
 *
 * Las coordenadas x/y de formations.js están definidas para orientación vertical.
 * En desktop se transforman matemáticamente:
 *   x_h = 100 - y_v   (el eje horizontal desktop = invertido del eje vertical mobile)
 *   y_h = x_v         (el eje vertical desktop = eje horizontal mobile)
 *
 * Esto evita el CSS rotate que desalineaba los slots.
 */
export default function transformSlot(slot, isHorizontal) {
  if (!isHorizontal) return slot;
  return {
    ...slot,
    x: 100 - slot.y,
    y: slot.x,
  };
}